import React from 'react';
import { CheckBox } from '@ui-kitten/components';
import styled from '@alucio/lux-ui/src/theming/util/styled';
/** APPEARANCE */
export var DNACheckboxAppearanceEnum;
(function (DNACheckboxAppearanceEnum) {
    DNACheckboxAppearanceEnum["default"] = "default";
    DNACheckboxAppearanceEnum["outline"] = "outline";
})(DNACheckboxAppearanceEnum || (DNACheckboxAppearanceEnum = {}));
export const DNACheckboxAppearanceKeys = Object.keys(DNACheckboxAppearanceEnum);
/** STATUS */
export var DNACheckboxStatusEnum;
(function (DNACheckboxStatusEnum) {
    DNACheckboxStatusEnum["primary"] = "primary";
    DNACheckboxStatusEnum["success"] = "success";
    DNACheckboxStatusEnum["warning"] = "warning";
    DNACheckboxStatusEnum["danger"] = "danger";
})(DNACheckboxStatusEnum || (DNACheckboxStatusEnum = {}));
export const DNACheckboxStatusKeys = Object.keys(DNACheckboxStatusEnum);
/** CONTEXT */
export var DNACheckboxContextEnum;
(function (DNACheckboxContextEnum) {
    DNACheckboxContextEnum["altBg"] = "altBg";
})(DNACheckboxContextEnum || (DNACheckboxContextEnum = {}));
export const DNACheckboxContextKeys = Object.keys(DNACheckboxContextEnum);
const parseComponentStyle = (source) => {
    const { containerBorderRadius, containerBorderWidth, containerBorderColor, containerPaddingLeft, containerPaddingRight, containerPaddingVertical, } = source;
    return {
        containerStyle: {
            borderRadius: containerBorderRadius,
            borderWidth: containerBorderWidth,
            borderColor: containerBorderColor,
            paddingLeft: containerPaddingLeft,
            paddingRight: containerPaddingRight,
            paddingVertical: containerPaddingVertical,
        },
    };
};
export const DNACheckbox = (props) => {
    const { eva, ...rest } = props;
    const { containerStyle } = parseComponentStyle(eva.style);
    return (<CheckBox style={containerStyle} {...rest}/>);
};
// We reuse the CheckBox style
export default styled('CheckBox')(DNACheckbox);
//# sourceMappingURL=DNACheckbox.js.map